<template>
	<div class="search-brand-initial">
		<select
			class="select search-brand-initial__select"
			v-model="selectedBrandId"
		>
			<option
				v-for="item in brandList"
				:key="item.id"
				:value="item.id"
				:disabled="item.id === null"
			>
				{{ item.title }}
			</option>
		</select>
		<input
			class="search-brand-initial__input"
			type="text"
			placeholder="검색어 + Enter"
			:value="searchKeyword"
			@input="
				e => {
					searchKeyword = e.target.value;
				}
			"
			@keypress.enter.prevent
			@keyup.enter.prevent="enterSearch"
		/>
		<RadioList
			v-model="idInitial"
			:radio-list="
				initialList.map((item, idx) => ({ id: idx, value: item }))
			"
			input-class="search-by-enter__target"
			class="search-brand-initial__initial-list"
			@inputWithOptional="changeInitial"
		/>
	</div>
</template>

<script>
	import RadioList from '@/components/RadioList';

	export default {
		name: 'SearchBrandInitial',
		components: { RadioList },
		data() {
			const initialList = [
				'ㄱ',
				'ㄴ',
				'ㄷ',
				'ㄹ',
				'ㅁ',
				'ㅂ',
				'ㅅ',
				'ㅇ',
				'ㅈ',
				'ㅊ',
				'ㅋ',
				'ㅌ',
				'ㅍ',
				'ㅎ',
				'숫자/영어 등',
			];
			const idInitial = 0;
			return {
				initialList,
				idInitial,
				titleInitial: initialList[idInitial],
				searchKeyword: '',
				brandList: [],
				selectedBrandId: null,
			};
		},
		watch: {
			selectedBrandId(idBrand) {
				this.$emit('change', {
					...this.brandList.filter(item => item.id === idBrand)[0],
					idInitial: this.idInitial,
					searchKeyword: this.searchKeyword,
				});
			},
		},
		mounted() {
			if (!this.$route.query.brandId) this.getBrandList();
		},
		methods: {
			parsingBrandList(list, firstObj) {
				return list.reduce(
					(acc, item) => {
						acc.push({
							id: item.idBrand,
							title: `[${item.idBrand}] ${item.brandTitle}`,
						});
						return acc;
					},
					[firstObj]
				);
			},
			async getBrandListBySearch() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/brands/word/${this.searchKeyword}`
					);
					const list = data.brands;
					if (list < 1) {
						alert('검색결과가 없습니다.');
						return;
					}
					this.idInitial = null;
					this.brandList = this.parsingBrandList(list, {
						id: null,
						title: `${this.searchKeyword} (${data.total})`,
					});
					this.selectedBrandId =
						typeof brandId === 'number' ? brandId : null;
				} catch (err) {
					console.error(err);
					alert(
						'브랜드 목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			debounceSearch: _.debounce(async function () {
				await this.getBrandListBySearch();
			}, 500),
			enterSearch() {
				if (this.searchKeyword.length < 2) {
					alert('2글자 이상 검색 가능합니다.');
					return;
				}
				this.$store.commit('toggleSpinner', true);
				this.debounceSearch();
			},
			async getBrandList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/brands/firstWord/${this.idInitial}`
					);
					this.brandList = this.parsingBrandList(data.brands, {
						id: null,
						title: `${this.titleInitial} (${data.total})`,
					});
					this.selectedBrandId = null;
				} catch (err) {
					console.error(err);
					alert(
						'브랜드 목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			changeInitial({ name, id }) {
				this.idInitial = id;
				this.titleInitial = name;
				this.getBrandList();
			},
		},
	};
</script>

<style lang="scss" scoped>
	$inputWidth: 200px;

	DIV {
		.search-brand-initial:after {
			content: '';
			display: block;
			clear: both;
		}

		.search-brand-initial__select {
			float: left;
			display: block;
			width: $inputWidth;
			margin-right: 8px;
		}

		.search-brand-initial__input {
			float: left;
			width: $inputWidth;
		}

		.search-brand-initial__initial-list {
			margin-top: 8px;
		}
	}
</style>
